import React from 'react';
import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { themeState, logoPreferencesState } from '../../Recoil/RecoilState';
import { getLogoFilter } from '../../utils/logoFilters';

// استيراد اللوجو الأصلي
import logoOriginal from '../../Images/logo.png';

// محاولة استيراد لوجوهات مخصصة (اختيارية)
let logoLight, logoHighContrast;
try {
  logoLight = require('../../Images/logo-light.png');
} catch (e) {
  logoLight = null;
}

try {
  logoHighContrast = require('../../Images/logo-high-contrast.png');
} catch (e) {
  logoHighContrast = null;
}

const ThemeLogo = ({ 
  alt = "Logo", 
  sx = {}, 
  onClick,
  height = "auto",
  width = "auto"
}) => {
  const currentTheme = useRecoilValue(themeState);
  const logoPreferences = useRecoilValue(logoPreferencesState);
  const logoFilter = getLogoFilter(currentTheme);

  // تحديد مصدر اللوجو
  const getLogoSrc = () => {
    if (!logoPreferences.useCustomLogos) {
      return logoOriginal;
    }

    switch (currentTheme) {
      case 'light':
        return logoLight || logoOriginal;
      case 'highContrast':
        return logoHighContrast || logoOriginal;
      case 'dark':
      default:
        return logoOriginal;
    }
  };

  const logoSrc = getLogoSrc();
  const shouldUseFilter = !logoPreferences.useCustomLogos || 
    (currentTheme === 'light' && !logoLight) ||
    (currentTheme === 'highContrast' && !logoHighContrast) ||
    currentTheme === 'dark';

  return (
    <Box
      component="img"
      src={logoSrc}
      alt={alt}
      onClick={onClick}
      sx={{
        height,
        width,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'opacity 0.3s ease-in-out, filter 0.3s ease-in-out',
        filter: shouldUseFilter ? logoFilter : 'none',
        '&:hover': onClick ? {
          opacity: 0.8,
        } : {},
        ...sx,
      }}
    />
  );
};

export default ThemeLogo; 